/* Pipglen - seasonal switch (shared). Sets <html data-pl-season="winter"|"off">.
   Winter turns ON by itself from Dec 1 2026 00:00 to Jan 2 2027 23:59 America/Los_Angeles and OFF again after.
   ONE KILL SWITCH: PL_SEASON_KILL below (or window.PL_SEASON_KILL = true set before this file loads,
   e.g. from a theme setting). true = every seasonal look is off for everyone, instantly.
   Load in <head>, NOT deferred, so there is no flash: <script src="{{ 'pl-season.js' | asset_url }}"></script> */
(function () {
  'use strict';
  var PL_SEASON_KILL = false; /* <- the single kill switch */
  var PL_SEASONS = [
    { name: 'winter', from: '2026-12-01', to: '2027-01-02' } /* inclusive, America/Los_Angeles */
  ];
  var TZ = 'America/Los_Angeles', root = document.documentElement, q = {};
  try { location.search.replace(/^\?/, '').split('&').forEach(function (p) { var a = p.split('='); if (a[0]) q[decodeURIComponent(a[0])] = decodeURIComponent(a[1] || ''); }); } catch (e) {}
  var QA = q._pl_qa === '1'; /* QA overrides work ONLY on a preview URL that carries _pl_qa=1 */

  function ptDate(d) {
    try {
      return new Intl.DateTimeFormat('en-CA', { timeZone: TZ, year: 'numeric', month: '2-digit', day: '2-digit' }).format(d);
    } catch (e) { /* Intl missing: approximate PT as UTC-8 */
      var t = new Date(d.getTime() - 8 * 3600e3);
      return t.getUTCFullYear() + '-' + ('0' + (t.getUTCMonth() + 1)).slice(-2) + '-' + ('0' + t.getUTCDate()).slice(-2);
    }
  }
  function compute() {
    var kill = (typeof window.PL_SEASON_KILL === 'boolean') ? window.PL_SEASON_KILL : PL_SEASON_KILL;
    if (kill) return 'off';
    if (QA && /^(off|winter)$/.test(q.pl_season || '')) return q.pl_season;
    var today = (QA && /^\d{4}-\d{2}-\d{2}$/.test(q.pl_date || '')) ? q.pl_date : ptDate(new Date());
    for (var i = 0; i < PL_SEASONS.length; i++) if (today >= PL_SEASONS[i].from && today <= PL_SEASONS[i].to) return PL_SEASONS[i].name;
    return 'off';
  }
  function ls(k, v) { try { if (v === undefined) return localStorage.getItem(k); localStorage.setItem(k, v); } catch (e) {} }

  var season = compute();
  root.setAttribute('data-pl-season', season);
  /* visitor choices (winter only): snow on/off, sunny winter-break look */
  function applyPrefs() {
    root.setAttribute('data-pl-snow', ls('pl_winter_snow') === 'off' ? 'off' : 'on');
    root.setAttribute('data-pl-winter-style', ls('pl_winter_style') === 'sunny' ? 'sunny' : 'snow');
  }
  applyPrefs();
  /* kill switch is also published as html[data-pl-kill="1"] (read by pl-season.css and the Holiday picks row) */
  function killed() { return (typeof window.PL_SEASON_KILL === 'boolean') ? window.PL_SEASON_KILL : PL_SEASON_KILL; }
  if (killed()) root.setAttribute('data-pl-kill', '1');
  window.PLSeason = { get: function () { return root.getAttribute('data-pl-season'); }, recompute: compute, killed: killed };

  /* small visitor control, only while winter is on and only on pages with a seasonal game */
  function addControls() {
    if (root.getAttribute('data-pl-season') !== 'winter' || document.querySelector('.pl-season-ctl') || !document.querySelector('.pl-seasonal')) return;
    var w = document.createElement('div'); w.className = 'pl-season-ctl'; w.setAttribute('role', 'group'); w.setAttribute('aria-label', 'Winter look');
    function mk(label, key, onVal, offVal, isOn) {
      var b = document.createElement('button'); b.type = 'button';
      function sync() { var on = isOn(); b.setAttribute('aria-pressed', on ? 'true' : 'false'); b.textContent = label + ': ' + (on ? 'on' : 'off'); }
      b.addEventListener('click', function () { ls(key, isOn() ? offVal : onVal); applyPrefs(); sync(); });
      sync(); return b;
    }
    w.appendChild(mk('Snow', 'pl_winter_snow', 'on', 'off', function () { return root.getAttribute('data-pl-snow') !== 'off'; }));
    w.appendChild(mk('Sunny', 'pl_winter_style', 'sunny', 'snow', function () { return root.getAttribute('data-pl-winter-style') === 'sunny'; }));
    document.body.appendChild(w);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', addControls); else addControls();
})();
